export const MINIMUM_TERM_CHARACTERS_FOR_SUGGESTIONS = 3;
export const MAX_SUGGESTED_CATEGORIES = 3;
